import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { createClient } from '@segment/api/staticSiteBackend/client';
export var useTwilioPhoneValidation = function useTwilioPhoneValidation() {
  var client = createClient();

  var lookupPhone = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(phone) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", client.get("/lookup/phone/".concat(phone)));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function lookupPhone(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    lookupPhone: lookupPhone
  };
};